import { GraphQL } from "@graphql/graphQL";
import { UpdatePeriodApplianceMutation, UpdatePeriodApplianceMutationVariables } from "@models/graphql";
import { ApolloError } from "apollo-client";
import { useState } from "react";
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

const defaultUpdatePeriodApplianceOptions: MutationHookOptions<UpdatePeriodApplianceMutation, UpdatePeriodApplianceMutationVariables> = {

};

export const useUpdatePeriodAppliance = (options?: MutationHookOptions<UpdatePeriodApplianceMutation, UpdatePeriodApplianceMutationVariables>) => {
    const [hookState, setHookState] = useState<{
        isLoading: boolean;
        data?: UpdatePeriodApplianceMutation;
        error?: ApolloError;
    }>({
        isLoading: false
    });

    const [mutation] = useMutation<UpdatePeriodApplianceMutation, UpdatePeriodApplianceMutationVariables>(GraphQL.updatePeriodAppliance);

    const updatePeriodAppliance = async (variables: UpdatePeriodApplianceMutationVariables) => {
        setHookState({
            isLoading: true
        });

        try {
            const response = await mutation({
                ...defaultUpdatePeriodApplianceOptions,
                ...options,
                variables
            });

            setHookState({
                data: response.data,
                isLoading: false
            });

            return {
                data: response.data
            };
        } catch (error) {

            setHookState({
                error,
                isLoading: false
            });

            return {
                error
            };
        }
    };

    return {
        isLoading: hookState.isLoading,
        error: hookState.error,
        data: hookState.data,
        updatePeriodAppliance
    };
};
